import { useState, useEffect } from 'react';

/*
NOTE: Hook is based on the IntersectionObserver API
https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
Arg - ref: of the element you are checking is on screen.
Arg - options: an optional object which can be used to set the root, rootMargin and threshold
https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#intersection_observer_options
*/

const useOnScreen = (ref, options) => {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      // State is updated when the observer callback fires to determine if element is visible
      setIntersecting(entry.isIntersecting);
    }, options);
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.unobserve(ref.current);
    };
  }, []);
  return isIntersecting;
};

export default useOnScreen;
